﻿import 'jquery-validation-unobtrusive';
import InputFormatting  from "../modules/inputFormatting";
import 'bootstrap';
import M from 'materialize-css' //needed to attach the jquery plugins
import * as $ from 'jquery';
import '@selectize/selectize/dist/js/selectize';
import '@selectize/selectize/dist/css/selectize.bootstrap5.css';
import Chart from 'chart.js/auto';
import Notifications from "../modules/notifications";
import Stepper from 'bs-stepper';

import Quill from 'quill';

$.validator.setDefaults({
    highlight: function (element, errorClass, validClass)
    {
        $(element).addClass('invalid');
        $(element).siblings(".field-validation-error").find('.invalid-feedback').addClass('d-block');
    },
    unhighlight: function (element, errorClass, validClass)
    {
        $(element).removeClass('invalid');
        $(element).siblings(".field-validation-error").find('.invalid-feedback').removeClass('d-block');
    }
});

$.validator.addMethod("dateRange", function (value, element, params) {
    try {
        let dateFrom = new Date(value);
        let dateTo =  new Date($(params).val());
        if (dateFrom <= dateTo) {
            return true;
        }
    } catch (e) {}
    return false;
});

// data-rule-date-range="#dateToId"
$.validator.addMethod("postcode", function (value, element, params) {
    return this.optional( element ) || window.isValid(value);
});

$.validator.unobtrusive.adapters.add("postcode", function (options) {
    options.rules["postcode"] = options.params;
    options.messages["postcode"] = options.message;
});
$.validator.unobtrusive.adapters.add("dateRange", function (options) {
    options.rules["dateRange"] = options.params;
    options.messages["dateRange"] = options.message;
});


$(document).ready(function () {
    let formatting = new InputFormatting();
    let notifications = new Notifications();

    $('.selectize-type').selectize({
        valueField: "optionType",
        labelField: "optionType",
        render: {
            item: function (item, escape) {
                //py-0 ps-3 --outer wrapper select-input
                return ` <div class='row pt-2' style='text-indent:0'>
                                <div class='col-3 btn btn-floating btn-xs ${item.optionColour}'>
                                    <i class='fas ${item.optionIcon}'></i>
                                </div>
                                <div class='col-9'>
                                    <div class='pt-2'>${item.optionType}</div>
                                </div>
                            </div>`
            },
            option: function (item, escape) {
                return (
                    ` <div class='row px-0 ps-2 pt-2 mx-0' style='line-height:23px;text-indent:0'>
                                <div class='col-3 btn btn-floating btn-sm ${item.optionColour}'>
                                    <i class='fas ${item.optionIcon}'></i>
                                </div>
                                <div class='col-9'>
                                    <div class='fw-bold'>${item.optionType}</div>
                                    <div class='text-gray-500 small text-wrap'>${item.optionDescription}</div>
                                </div>
                            </div>`
                );
            }
        }
    });

    $("select").selectize();
    $('.datepicker').datepicker();

    try{

        const toolbarOptions = [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            ['blockquote', 'code-block'],
            ['link', 'image'],

            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
            [{ 'color': [] }],          // dropdown with defaults from theme
            [{ 'align': [] }],
            ['clean']                                         // remove formatting button
        ];

        let editor = $('.editor').data('elm');
        
        const quill = new Quill('.editor', {
            modules: {
                toolbar: toolbarOptions
            },
            theme: 'snow',
        });

        quill.root.innerHTML = $('#'+editor).val();

        quill.on('text-change', function() {
            $('#'+editor).val( quill.root.innerHTML);
        });

        if($('#'+editor).attr('disabled') === 'disabled') {
            quill.enable(false);
        }
        

    } catch (e) {
        console.log(e);
    }

    if($('.bs-stepper').length > 0) {
        var stepper = new Stepper($('.bs-stepper')[0],{
            linear: true,
        });

        $('.stepper-next').on("click",function () {
            stepper.next();
        });

        $('.stepper-previous').on("click",function () {
            stepper.previous();
        });
    }
    
    try {
        
        let labels = $('#recentWork').data('labels');
        let values = $('#recentWork').data('datasets');
        
        //Find the biggest value and round to nearest 10
        var max = Math.max(...values[0]);
        max = Math.ceil(max / 10) * 10;
        
        var config = {
            type: 'doughnut',
            labels: labels,
            data: {
                datasets: [
                    {
                        label: labels[0][0],
                        data: [
                            values[0][0], max-values[0][0]
                        ],
                        backgroundColor: [
                            "#009AC8",
                            "rgba(0,0,0,0)",
                        ],
                        borderColor: "#041723",
                        borderRadius: 100,
                        hoverBorderColor: "#041723",
                    },
                    {
                        label: labels[0][1],
                        data: [
                            values[0][1], max-values[0][1]
                        ],
                        backgroundColor: [
                            "#df4e4e",
                            "rgba(0,0,0,0)",
                        ],
                        borderColor: "#041723",
                        borderRadius: 100,
                        hoverBorderColor: "#041723"
                    },
                    {
                        label: labels[0][2],
                        data: [
                            values[0][2], max-values[0][2]
                        ],
                        backgroundColor: [
                            "#B15AA8",
                            "rgba(0,0,0,0)",
                        ],
                        borderColor: "#041723",
                        borderRadius: 100,
                        hoverBorderColor: "#041723",
                    },
                    {
                        label: labels[0][3],
                        data: [
                            values[0][3], max-values[0][3]
                        ],
                        backgroundColor: [
                            "#f7a025",
                            "rgba(0,0,0,0)",
                        ],
                        borderColor: "#041723",
                        borderRadius: 100,
                        hoverBorderColor: "#041723",
                    },
                    {
                        label: labels[0][4],
                        data: [
                            values[0][4], max-values[0][4]
                        ],
                        backgroundColor: [
                            "#39ef07",
                            "rgba(0,0,0,0)",
                        ],
                        borderColor: "#041723",
                        borderRadius: 100,
                        hoverBorderColor: "#041723",
                    },
                ],
            },
            options: {
                responsive: true,
                cutoutPercentage: 70,
            }
        };
        var ctx = document.getElementById("recentWork").getContext("2d");
        var myDoughnut = new Chart(ctx, config);

        const chartOptions = {
            maintainAspectRatio: false,
            elements: {
                point: {
                    radius: 0
                },
            },
            scales: {
                x: {
                    grid: {
                        display: false
                    }
                },
                y: {
                    grid: {
                        display: false
                    }
                }
            }
        };

        var ctx2 = document.getElementById('estimateVsActual').getContext('2d');

        let chart2Labels = $('#estimateVsActual').data('labels');
        let chart2Values = $('#estimateVsActual').data('datasets');
        var chart = new Chart(ctx2, {
            type: "bar",
            data: {
                labels: chart2Labels[0],
                datasets: [
                    {
                        label: "Estimate",
                        backgroundColor: "rgba(101, 116, 205, 0.1)",
                        borderColor: "rgba(101, 116, 205, 0.8)",
                        borderWidth: 2,
                        data: chart2Values[0],
                    },
                    {
                        label: "Actual",
                        backgroundColor: "rgba(205,101,120,0.1)",
                        borderColor: "rgba(205,101,132,0.8)",
                        borderWidth: 2,
                        data: chart2Values[1],
                        type: "line",
                    },
                ],
            },
            options: chartOptions
        });
    } catch (e) {
        
    }

});

